import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../helpers';

@Component({
  selector: 'app-password-renew',
  templateUrl: './password-renew.component.html',
  styleUrls: ['./password-renew.component.scss']
})
export class PasswordRenewComponent implements OnInit {

  public renewForm = new FormGroup({
    password: new FormControl('', Validators.required),
    password2: new FormControl('', Validators.required)
  });

  public renewError = null;
  public renewSuccess = false;
  public renewInProgress = false;
  public hideForm = false;

  public key = null;
  public username = null;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private helper: HelperService,
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (!params.key) {
        this.renewError = 'Manjkajoči podatki za ponastavitev gesla';
        this.hideForm = true;
      }
      if (!params.login) {
        this.renewError = 'Manjkajoči podatki za ponastavitev gesla';
        this.hideForm = true;
      }
      this.key = params.key;
      this.username = params.login;
    });
  }

  renew(form) {
    this.renewError = null;
    this.renewSuccess = false;

    if (form.controls.password.value !== form.controls.password2.value) {
      this.renewError = 'Gesli se ne ujemata';
      return;
    }

    if (form.invalid) {
      this.renewError = 'Vnesite novo geslo';
      return;
    }

    this.renewInProgress = true;
    this.http.post(this.helper.getResetUrl() + '/renew', {
      user: this.username,
      key: this.key,
      password: form.controls.password.value,
    }).subscribe((response: any) => {
      this.renewInProgress = false;
      if (response.success === false) {
        switch (response.data.error) {
          case 'Invalid user':
            this.renewError = 'Uporabnik ne obstaja';
            break;
          case 'Invalid key':
            this.renewError = 'Ključ ni pravilen';
            break;
          case 'Invalid password':
            this.renewError = 'Geslo ni ustrezno';
            break;
          case 'Password to short':
            this.renewError = 'Geslo je prekratko';
            break;
          case 'Expired key':
            this.renewError = 'Ključ za ponastavitev je pretekel';
            break;
          default:
            this.renewError = 'Napaka pri ponastavitvi gesla';
            break;
        }
      } else {
        this.renewSuccess = true;
      }
    }, (error) => {
      this.renewInProgress = false;
      this.renewSuccess = false;
      this.renewError = 'Napaka pri ponastavitvi gesla';
    });
  }

}
